var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxChecked = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M4.9 8.45 2.4 5.97l.795-.785L4.9 6.875 8.605 3.2l.795.79z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  stroke: "#348CFD",
  fill: "#348CFD",
  x: 0.5,
  y: 0.5,
  width: 11,
  height: 11,
  rx: 3
}), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  xlinkHref: "#a"
}))));
export { SvgCheckboxChecked as ReactComponent };
export default __webpack_public_path__ + "assets/images/checkbox-checked.svg";